export default "__VITE_ASSET__aa2e1c48__"